import { z } from 'my-zod'
import { operatorSystemView } from './operator-system-view'

export const operatorAdminView = operatorSystemView
export type operatorAdminView = z.infer<typeof operatorAdminView>

export const operatorAdminResponse = z.object({
  operator: operatorAdminView,
  warning: z.string().nullable()
})
export type operatorAdminResponse = z.infer<typeof operatorAdminResponse>
